module.exports = __webpack_public_path__ + "img/开放第三方@3x.068730fb.png";